import {createStore} from 'vuex'

export default createStore({
    state: {
        HOME_PAGE: 0, HOME_SAISHI: 0, token: '', signUpForm: {}, associationName: ''
    }, getters: {}, mutations: {
        SET_HOME_PAGE(state, type) {
            state.HOME_PAGE = type
        },
        SET_HOME_SAISHI(state, type) {
            state.HOME_SAISHI = type
        },
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_SIGNUP_FORM(state, value) {
            state.signUpForm = value
        },
        SET_ASSOCIATIONNAME(state, value) {
            state.associationName = value
        }
    }, actions: {}, modules: {}
})
